import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { ActionIcon, Group, rem } from '@mantine/core';
export const LoginButtonMobile = () => {
  const {
    setOpenModal
  } = useModalAction();
  return <Group justify="center" align="center" h={rem(95)} hiddenFrom="sm">
      <ActionIcon variant="transparent" onClick={() => setOpenModal(MODAL.LOGIN)}>
        <Icons className="icon-pr-line-log-in" fontSize={24} color="var(--mantine-color-prime-0)" />
      </ActionIcon>
    </Group>;
};